<template>
    <div style="height: 100%;width: 100%;">
        <van-nav-bar title="会员信息" left-text="返回" left-arrow @click-left="historyBack"/>
        
            <el-form :inline="true" class="demo-form-inline" size="mini">
                <el-form-item label="门店">
                    <el-select v-model="storeid" placeholder="门店选择" @change="storeChange">
                      <el-option :label="item.brandname" :value="item.brandid" v-for="(item,key) in brands" :key="key"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item >
                    <el-switch v-model="checked" active-text="红灯" inactive-text="黄灯" @change="getBeautyCardRedLamp()"></el-switch>
                </el-form-item>
            </el-form>
        
        <el-table height="calc(100% - 6rem)" :data="beautyHeads" show-header style="width: 100%">
            <el-table-column prop="staffname" align="center" label="员工姓名"></el-table-column>
            <el-table-column prop="membername" align="center" label="会员姓名">
                
            </el-table-column>
            <el-table-column prop="islooksay" align="center" label="到店/天">
                <template slot-scope="scope">
                    {{$moment(scope.row.lastdate).format('MM-DD')}}({{scope.row.days}})
                </template>
            </el-table-column>
            <el-table-column prop="stafftype" align="center" label="消费明细">
                <template slot-scope="scope">
                    <el-button type="danger" icon="el-icon-s-opportunity" size="mini" v-if="checked" circle @click.stop="openBeautyCardTran(scope.row)"></el-button>
                    <el-button type="warning" icon="el-icon-s-opportunity" size="mini" v-else circle @click.stop="openBeautyCardTran(scope.row)"></el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                beautyHeads:[],
                checked:true,
                storeid:"",
                brands:[],
            }
        },
        created: function () {
            this.storeid=localStorage.getItem("storeid");
            this.getBeautyCardRedLamp();
            this.getStoreInfoByStructsOpen();
        },
        methods: {
            storeChange(val){
                localStorage.setItem("storeid",val);
                this.storeid=val;
                this.getBeautyCardRedLamp();
            },
            getStoreInfoByStructsOpen(){
                let parentstoreid=localStorage.getItem("parentstoreid");
                let staffid=localStorage.getItem("staffid");
                this.$post("store/getStoreByStructsByStaffId",{storeid:parentstoreid,staffid:staffid}).then(res=>{
                    if(res.sucess){
                        this.brands=res.object;
                    }
                    else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            },
            openBeautyCardTran(row){
                this.$router.push({path:"/beautycardtran",query:{
                    cardid:row.cardid,
                }});
            },
            getBeautyCardRedLamp(){
                let type=1;
                if(this.checked==false){
                    type=2;
                }
                this.$post("beautymanager/getBeautyCardRedLamp",{storeid:this.storeid,type:type}).then(res=>{
                    if(res.sucess){
                        this.beautyHeads=res.object;
                    }
                    else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/page/beauty/beautylamp.vue